import labelled from "./labelledFormComponent";

const textFieldDefaultProps = { type: "text" };

const FormTextField = labelled("input", textFieldDefaultProps);

export default FormTextField;
